/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
import UlListWrapper from './UlList.style';
import Icon from '../Icon';
import theme from '../../styles/theme';


const UlList = (props) => {
  /* STATE ---------------------------------*/
  const [coloredItems, setColoredItems] = React.useState({});

  /* METHODS ---------------------------------*/

  const selectItem = (i) => {
    const updatedState = {
      ...coloredItems,
    };
    updatedState[i] = !updatedState[i];
    setColoredItems(updatedState);
  };

  /* RENDER ---------------------------------*/
  const {
    items,
  } = props;

  return (
    <UlListWrapper>
      {items.map((item, index) => (
        <div key={item.key} className="row-wrapper">
          <button
            type="button"
            className="button-check"
            onClick={() => { selectItem(index); }}
          >
            <Icon
              name="circleCheckIcon"
              color={coloredItems[index] ? theme.icon.greenIcon : theme.textColor.suvaGray}
            />
          </button>
          <span className="text-content">{item}</span>
        </div>
      ))}
    </UlListWrapper>
  );
};

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
UlList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.element
  ).isRequired
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default UlList;
